import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * @user: antes
 * @emial: tangzhlyd@gmail.com
 * @data: 2021/8/12 下午5:13
 */ export function CleanCache() {
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx("h2", {
                children: "版本更新 建议按照下面视频清理缓存"
            }),
            /*#__PURE__*/ _jsx("video", {
                controls: true,
                width: 736,
                children: /*#__PURE__*/ _jsx("source", {
                    src: "https://rantion-dfs.oss-cn-shenzhen.aliyuncs.com/prod/web/2021-08-12/vc-upload-1628761932643-3-清理缓存.mp4",
                    type: "video/mp4"
                })
            })
        ]
    });
}
